import { validateConfirmEmail, validateEmail } from "./validateEmail"
import { validatePhone } from "./validatePhone";
import i18n from "../../../i18n";

export type CreateUserErrorObj = {
    name: {
        error: boolean,
        message: string
    },
    surname: {
        error: boolean,
        message: string
    },
    phone: {
        error: boolean,
        message: string
    },
    email: {
        error: boolean,
        message: string
    },
    confirmEmail: {
        error: boolean,
        message: string
    },
    role: {
        error: boolean,
        message: string
    }
}

export const validateCreateUserData = (data: any) => {
    const errorObj: CreateUserErrorObj = {
        name: {
            error: false,
            message: ''
        },
        surname: {
            error: false,
            message: ''
        },
        phone: {
            error: false,
            message: ''
        },
        email: {
            error: false,
            message: ''
        },
        confirmEmail: {
            error: false,
            message: ''
        },
        role: {
            error: false,
            message: ''
        }
    };

    if (!data.name) {
        errorObj.name.error = true;
        errorObj.name.message = i18n.t('errors.requiredName');
    }

    if (!data.surname) {
        errorObj.surname.error = true;
        errorObj.surname.message = i18n.t('errors.requiredSurname');
    }

    if (!data.email) {
        errorObj.email.error = true;
        errorObj.email.message = i18n.t('errors.requiredEmail');
    }

    if (!data.phone) {
        errorObj.phone.error = true;
        errorObj.phone.message = i18n.t('errors.requiredPhone');
    } else if (!validatePhone(data.phone)) {
        errorObj.phone.error = true;
        errorObj.phone.message = i18n.t('errors.incorrectFormatPhone');
    }

    if (!data.role.id || !data.role.value) {
        errorObj.role.error = true;
        errorObj.role.message = i18n.t('errors.requiredRole');
    }

    if (!data.email) {
        errorObj.email.error = true;
        errorObj.email.message = i18n.t('errors.requiredEmail');
    } else if (!validateEmail(data.email)) {
        errorObj.email.error = true;
        errorObj.email.message = i18n.t('errors.incorrectFormatEmail');
    }

    if (!data.confirmEmail) {
        errorObj.confirmEmail.error = true;
        errorObj.confirmEmail.message = i18n.t('errors.requiredConfirmEmail');
    } else if (!validateEmail(data.confirmEmail)) {
        errorObj.confirmEmail.error = true;
        errorObj.confirmEmail.message =  i18n.t('errors.incorrectFormatConfirmEmail');
    } else if (!validateConfirmEmail(data.email, data.confirmEmail)) {
        errorObj.confirmEmail.error = true;
        errorObj.confirmEmail.message = i18n.t('errors.confirmEmailMustBeEqualToEmail');
    }

    return errorObj;
}